import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";
import url from "../Url";
import "./Navbar.css";

// Import images
import { supportIcons } from "../assets/supportIcons";

// Constants
const DESIRED_ORDER = [
  'Wood',
  'Vinyl',
  'Laminate',
  'Rugs, Carpets, Artificial Grass',
  'Cork Flooring',
  'Sport Flooring',
  'Stairs'
];

const VINYL_SUB_ORDER = [
  'Vinyl Planks',
  'Vinyl Tiles',
  'Sheet Vinyl',
  'Vinyl Composite (VCT)'
];

// Support Menu Component
const SupportMenu = ({ onClose }) => (
  <div className="dropdown">
    <div className="container">
      <div className="row">
        {Object.entries(supportIcons).map(([key, { icon, title, path }]) => (
          <div key={key} className="support-div text-center col-md-2">
            <Link to={path} onClick={onClose}>
              <img width="60px" height="60px" className="small" src={icon} alt={title} />
              <h3 className="title-text text-center">{title}</h3>
            </Link>
          </div>
        ))}
      </div>
    </div>
  </div>
);

// Submenu Component
const Submenu = ({ submenu, onClose, onSubmenuClick, activeIndex, selectedSubmenu }) => (
  <div className="dropdown">
    <div className="container">
      <div className="row">
        <div className="col-md-4 dropdown-column">
          {submenu?.children?.length > 0 && (
            <div style={{
              width: "100%",
              textAlign: "start",
              display: "flex",
              justifyContent: "space-between",
            }}>
              <h5 style={{
                fontWeight: 800,
                marginBottom: "20px",
              }}>
                {submenu.name}
              </h5>
              <Link onClick={onClose} to={`/${submenu.slug}`}>
                <button className="shop-all">Shop All</button>
              </Link>
            </div>
          )}
          {submenu.children?.sort((a, b) => {
            const order = submenu.name === 'Vinyl' ? VINYL_SUB_ORDER : DESIRED_ORDER;
            return order.indexOf(a.name) - order.indexOf(b.name);
          }).map((sub, index) => (
            <div key={index} style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              cursor: "pointer",
            }}>
              {sub.children?.length > 0 ? (
                <li
                  className="list"
                  style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  }}
                  onClick={() => onSubmenuClick(index)}
                >
                  <span>{sub.name}</span>
                  <span className="submenu-arrow">
                    <MdKeyboardArrowRight size={18} color="grey" />
                  </span>
                </li>
              ) : (
                <Link 
                  className="list" 
                  to={`/${sub.slug}`}
                  onClick={onClose}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                >
                  <span>{sub.name}</span>
                </Link>
              )}
            </div>
          ))}
        </div>
        <div className="col-md-4">
          <div>
            {selectedSubmenu !== null && submenu.children[selectedSubmenu]?.children?.length > 0 && (
              <div style={{
                width: "100%",
                justifyContent: "space-between",
                display: "flex",
              }}>
                <div style={{
                  textAlign: "start",
                }}>
                  <h5 style={{
                    fontWeight: 800,
                    marginBottom: "20px",
                  }}>
                    {submenu.children[selectedSubmenu]?.name}
                  </h5>
                </div>
                <Link onClick={onClose} to={`/${submenu.children[selectedSubmenu].slug}`}>
                  <button className="shop-all">Shop All</button>
                </Link>
              </div>
            )}
            {submenu.children?.filter((sub, index) => activeIndex === index && sub.children?.length > 0)
              .map(sub => sub.children?.map(subCat => (
                <div key={`${sub._id}-${subCat._id}`}>
                  <p className="sub-cat" style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}>
                    <Link 
                      className="list" 
                      to={`/${subCat.slug}`}
                      onClick={onClose}
                    >
                      {subCat.name}
                    </Link>
                  </p>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);

// Main Menu Item Component
const MenuItem = ({ menu, isVisible, onMenuClick, onSubmenuClick, activeIndex, selectedSubmenu, onClose }) => {
  if (menu.slug === "support") {
    return (
      <>
        <li className="menu-item custom-btn">
          <Link onClick={() => onMenuClick("Support")}>Support</Link>
        </li>
        {isVisible && <SupportMenu onClose={onClose} />}
      </>
    );
  }
  
  if (menu.slug === "blogs") {
    return (
      <li className="menu-item custom-btn">
        <Link onClick={onClose} to="/blog">Blogs</Link>
      </li>
    );
  }

  if (menu.slug === "brand") {
    return (
      <li className="menu-item">
        <Link onClick={onClose} to="brand">Brand</Link>
      </li>
    );
  }

  if (menu.slug === 'promotions' || menu.slug === 'accessories') {
    return null;
  }

  return (
    <>
      <li className="menu-item">
        <Link onClick={() => onMenuClick(menu.name)}>{menu.name}</Link>
      </li>
      {isVisible && (
        <Submenu
          submenu={menu}
          onClose={onClose}
          onSubmenuClick={onSubmenuClick}
          activeIndex={activeIndex}
          selectedSubmenu={selectedSubmenu}
        />
      )}
    </>
  );
};

// Main Header Component
function Header() {
  const [menuVisibility, setMenuVisibility] = useState({});
  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedSubmenu, setSelectedSubmenu] = useState(null);
  const [mainCat, setMainCat] = useState([]);
  const menuRef = useRef();
  const navigate = useNavigate();

  const handleMenuClick = (menuName) => {
    setMenuVisibility({});
    setMenuVisibility((prevState) => ({
      ...prevState,
      [menuName]: !prevState[menuName],
    }));
    setActiveIndex(null);
    setSelectedSubmenu(null);
  };

  const handleSubmenuClick = (index) => {
    setSelectedSubmenu(index);
    setActiveIndex(prev => prev === index ? null : index);
  };

  const closeAllMenus = () => {
    setMenuVisibility({});
    setActiveIndex(null);
    setSelectedSubmenu(null);
  };

  useEffect(() => {
    const fetchMenuData = async () => {
      try {
        const categoriesResponse = await axios.get(`${url}/api/category/getCat`);
        const categories = categoriesResponse.data.categoryList;
        
        let newMenuCategories = [...categories];
        
        // Try to get menu order settings, but don't fail if it's not available
        try {
          const menuOrderResponse = await axios.get(`${url}/api/settings/menu-order`);
          const menuSettingsOrder = menuOrderResponse.data.data.setting;

          // If menu order setting exists and is not empty, use it
          if (menuSettingsOrder && menuSettingsOrder.length > 0) {
            newMenuCategories = menuSettingsOrder.map(menuItem => {
              const category = categories.find(c => c.slug === menuItem.slug);
              return category || menuItem;
            });
          }
        } catch (menuOrderError) {
          console.log("Menu order settings not available, using default category order");
        }
        
        // Add custom Blogs menu item
        const supportIndex = newMenuCategories.findIndex(item => item.slug === 'support');
        if (supportIndex !== -1) {
          // Create a blogs menu item
          const blogsMenuItem = {
            _id: 'blogs-menu-item',
            name: 'Blogs',
            slug: 'blogs',
            children: []
          };
          
          // Insert after support
          newMenuCategories.splice(supportIndex + 1, 0, blogsMenuItem);
        }

        setMainCat(newMenuCategories);
      } catch (error) {
        console.error("Error fetching menu data:", error);
      }
    };

    fetchMenuData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        closeAllMenus();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="header">
      <div className="container">
        <div className="header-item item-center">
          <div className="menu-overlay"></div>
          <nav className="menu" ref={menuRef}>
            <ul className="main-menu">
              {mainCat.map((menu) => (
                <MenuItem
                  key={menu._id}
                  menu={menu}
                  isVisible={menuVisibility[menu.name]}
                  onMenuClick={handleMenuClick}
                  onSubmenuClick={handleSubmenuClick}
                  activeIndex={activeIndex}
                  selectedSubmenu={selectedSubmenu}
                  onClose={closeAllMenus}
                />
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
